// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order', {
        url: '/order',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/order/order.tpl.html',
        controller: 'MainOrderController as vm'
    });
}

// @ngInject
function MainOrderController() {
    var vm = this;
}

angular
    .module('main.order', [
        'orderarticles.api',
        'orders.api',
        'orders.api2',
        'reports.api2',
        'order.ordersearch',
        'order.orderdelivery',
        'order.purchaseorder',
        'order.assortmentplanning',
        'order.purchaseordersearch',
        'order.service',
        'order.purchaseorderanalysis',
        'purchaseorderanalysis.api',
        'order.transitReports',
        'order.intrastatReports',
        'order.afterSalesClaimReports',
        'order.deliveryPlanning',
        'order.deliveryPlanning.editDeliveryPlanningDialog',
        'order.orderRowCommentDialog'
    ])
    .config(stateConfig)
    .controller('MainOrderController', MainOrderController);
